import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import { useTheme } from 'styled-components';
import { useApp } from '../../contexts/App';
import { classNames } from '../../utils/styles';
import { Button, SectionContainer, SectionTitle } from '../styles';
import { Modal } from './components/Modal';
import { Spinner } from './components/Spinner';
import { SuccessModalContent } from './components/SuccessModalContent';
import { ContentContainer, FormGroup } from './styles';
import { autoResizeTextArea, preLoadImgIfIsRunningOnBrowser, safeBase64Encode, } from './utils';
export const Form = ({ section }) => {
    const { fields } = section;
    const theme = useTheme();
    const { contextProps } = useApp();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [isSubmitting, setSubmitting] = useState(true);
    const [showMessageFormError, setShowMessageFormError] = useState(false);
    const [invalidFormSvgUrl, setInvalidFormSvgUrl] = useState('');
    useEffect(() => {
        const invalidFormSvgUrl = `${contextProps.hostApi}/utils/svg/invalid-form-svg?bgColor=${safeBase64Encode(theme.secondary)}`;
        setInvalidFormSvgUrl(invalidFormSvgUrl);
        preLoadImgIfIsRunningOnBrowser(invalidFormSvgUrl);
    }, []);
    const isFormOk = () => {
        if (fields.name.active && !name.trim()) {
            return false;
        }
        if (fields.email.active &&
            (!email.trim() ||
                !document.getElementById('email').checkValidity())) {
            return false;
        }
        if (fields.phone.active && !phone.trim()) {
            return false;
        }
        if (fields.message.active && !message.trim()) {
            return false;
        }
        return true;
    };
    const submitHandler = async () => {
        if (!isFormOk()) {
            setShowMessageFormError(true);
            return;
        }
        setShowMessageFormError(false);
        setSubmitting(true);
        setShowModal(true);
        try {
            await callSubmitApi();
        }
        finally {
            setSubmitting(false);
        }
    };
    const onExitSuccessModal = () => {
        setShowModal(false);
        setName('');
        setEmail('');
        setPhone('');
        setMessage('');
    };
    const onSuccessLinkClick = () => {
        window.open(section.successRedirectLink);
        onExitSuccessModal();
    };
    const callSubmitApi = () => {
        if (contextProps.form?.submitUrl) {
            return fetch(contextProps.form?.submitUrl, {
                method: 'POST',
                body: JSON.stringify({
                    name,
                    email,
                    phone,
                    message,
                }),
            });
        }
        return new Promise((resolve) => {
            setTimeout(resolve, 2 * 1000);
        });
    };
    return (_jsxs(_Fragment, { children: [_jsxs(SectionContainer, { children: [_jsx(SectionTitle, { className: classNames({
                            nmb: showMessageFormError,
                        }), children: section.pageTitle }), _jsxs(ContentContainer, { invalidSvgIcon: invalidFormSvgUrl, showFormErrors: showMessageFormError, children: [showMessageFormError && _jsx("p", { children: contextProps.form.invalid }), _jsxs("form", { action: "", children: [fields.name.active && (_jsx(FormGroup, { children: _jsx("input", { required: true, type: "text", id: "name", name: "name", placeholder: contextProps.form.fields.name, value: name, onChange: (e) => setName(e.target.value), tabIndex: 1 }) })), fields.email.active && (_jsx(FormGroup, { children: _jsx("input", { required: true, type: "email", id: "email", name: "email", autoComplete: "off", placeholder: contextProps.form.fields.email, value: email, onChange: (e) => setEmail(e.target.value), tabIndex: 2 }) })), fields.phone.active && (_jsx(FormGroup, { children: _jsx(InputMask, { required: true, mask: "+99 (99) 9 9999-9999", type: "tel", id: "phoneNotASearchField", name: "phoneNotASearchField", autoComplete: "off", placeholder: contextProps.form.fields.phone, value: phone, onChange: (e) => setPhone(e.target.value), tabIndex: 3 }) })), fields.message.active && (_jsx(FormGroup, { children: _jsx("textarea", { required: true, id: "message", name: "message", placeholder: contextProps.form.fields.message, spellCheck: "false", onInput: (e) => {
                                                setMessage(e.currentTarget.value);
                                                autoResizeTextArea(e);
                                            }, rows: 1, value: message, tabIndex: 4 }) })), _jsx(Button, { className: "submitButton", onClick: () => submitHandler(), onKeyPress: () => submitHandler(), backgroundColor: theme.buttons, textColor: theme.textButtons, tabIndex: 5, children: section.buttonText })] })] })] }), showModal && (_jsx(Modal, { onExit: isSubmitting ? undefined : onExitSuccessModal, children: isSubmitting ? (_jsx(Spinner, { color: theme.primary })) : (_jsx(SuccessModalContent, { section: section, onLinkClick: onSuccessLinkClick, contextProps: contextProps })) }))] }));
};
